import { render } from "./Footer.vue?vue&type=template&id=50ed5a5d"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=50ed5a5d&lang=css"
script.render = render

export default script